<div class="d-none d-xl-flex d-xxl-flex justify-content-between" style="gap: 20px;">
    <div class="d-flex gap-3 align-items-center">
        <div style="width: 100px; height: 100px; background-color: #ffffff;">
            <a [routerLink]="['/product', productSuggestion.slug]">
                <img [appCachedImage]="productSuggestion.imageUrls[0]" style="width: 100px; height: 100px; object-fit: contain;"
                    [alt]="productSuggestion.name" [title]="productSuggestion.name" loading="lazy" />
            </a>
        </div>

        <div class="d-flex flex-column flex-grow-1" style="gap: 12px;">
            <a [routerLink]="['/product', productSuggestion.slug]" class="product-name">{{productSuggestion.name}}</a>

            <div *ngIf="!productSuggestion.hasProductVoucher && productSuggestion.pricingTablePrice < productSuggestion.basePrice">
              <img [src]="'assets/svg/tags/promo.svg'" style="width: auto; height: 28px;" alt="promo"  loading="lazy" />
            </div>

            <div *ngIf="productSuggestion.hasProductVoucher">
              <img [src]="'assets/svg/tags/promo-tag-orange.svg'" style="width: auto; height: 28px;" alt="promo tag orange"  loading="lazy" />
            </div>

            <ng-container *ngIf="productSuggestion.expiredDate">
                <div class="product-label expired tag-label">
                    <span class="m-0">{{ productSuggestion.expiredDate }}</span>
                </div>
            </ng-container>
        </div>
    </div>

    <ng-container [ngTemplateOutlet]="temp"
        [ngTemplateOutletContext]="{ productSuggestion: productSuggestion }"></ng-container>
</div>

<div class="d-flex d-xl-none d-xxl-none gap-3">
    <div class="d-flex flex-column" style="gap: 12px;">
        <div style="width: 80px; height: 80px; background-color: #ffffff;">
            <a [routerLink]="['/product', productSuggestion.slug]">
                <img [appCachedImage]="productSuggestion.imageUrls[0]" style="width: 80px; height: 80px; object-fit: contain;"
                    [alt]="productSuggestion.name"  loading="lazy" />
            </a>
        </div>

        <ng-container *ngIf="productSuggestion.expiredDate">
            <div class="product-label expired tag-label">
                <span class="m-0" style="font-size: 11px;">{{ productSuggestion.expiredDate }}</span>
            </div>
        </ng-container>
    </div>

    <div class="d-flex flex-column gap-2 w-100">
        <div class="d-flex flex-column mt-2" style="gap: 8px;">
            <a [routerLink]="['/product', productSuggestion.slug]" class="product-name">{{productSuggestion.name}}</a>

            <div *ngIf="!productSuggestion.hasProductVoucher && productSuggestion.pricingTablePrice < productSuggestion.basePrice">
              <img [src]="'assets/svg/tags/promo.svg'" style="width: auto; height: 28px;" alt="promo"  loading="lazy" />
            </div>

            <div *ngIf="productSuggestion.hasProductVoucher">
              <img [src]="'assets/svg/tags/promo-tag-orange.svg'" style="width: auto; height: 28px;" alt="promo tag orange"  loading="lazy" />
            </div>

            <ng-container [ngTemplateOutlet]="temp"
                [ngTemplateOutletContext]="{ productSuggestion: productSuggestion }"></ng-container>
        </div>
    </div>
</div>

<ng-template #temp let-productSuggestion="productSuggestion">
    <div class="d-flex flex-column align-items-end gap-2">
        <div class="d-flex flex-column align-items-end gap-2">
            <div class="price-rating justify-content-end"
                *ngIf="productSuggestion.stockStatus != 8 && productSuggestion.basePrice > 0">
                <ng-container *ngIf="!(productSuggestion | showPreviewPrice)">
                    <div style="font-size: 20px; font-weight: 600; color: #CF1322; text-align: end;">
                        {{ productSuggestion.pricingTablePrice | currencySymbol }}
                    </div>

                    <div *ngIf="productSuggestion.pricingTablePrice < productSuggestion.basePrice"
                        class="d-flex align-items-center gap-2 justify-content-end">
                        <del style="font-weight: 400; font-size: 14px; color: #6E6E72;">
                            {{ productSuggestion.basePrice | currencySymbol }}
                        </del>
                        <span style="font-weight: 400; font-size: 14px; color: #cf1322;">
                            -{{ Math.max(0.01, (productSuggestion.basePrice - productSuggestion.pricingTablePrice) /
                            productSuggestion.basePrice) | percent:'1.0-0' }}
                        </span>
                    </div>
                </ng-container>

                <ng-container *ngIf="productSuggestion | showPreviewPrice">
                    <app-deal-shock-preview-price class="d-none d-md-block d-lg-block d-xl-block d-xxl-block w-max-content"
                        [product]="productSuggestion" [p]="{
                            'p1': 'font-size: 18px !important',
                            'p3': 'font-size: 12px !important;',
                            'p4': 'font-size: 14px !important;',
                            'div1': 'align-items: flex-end !important; row-gap: 0px !important;',
                            'div2': 'flex-direction: row-reverse !important;'
                        }">
                    </app-deal-shock-preview-price>

                    <app-deal-shock-preview-price class="d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none w-max-content"
                        [product]="productSuggestion" [p]="{
                            'p1': 'font-size: 16px !important;',
                            'p3': 'font-size: 12px !important;',
                            'p4': 'font-size: 14px !important;',
                            'div1': 'align-items: flex-end !important; row-gap: 0px !important;',
                            'div2': 'flex-direction: row-reverse !important;'
                        }">
                    </app-deal-shock-preview-price>
                </ng-container>
            </div>

            <div *ngIf="productSuggestion.appliedPricingTable && productSuggestion.appliedPricingTable.subType == 0 && productSuggestion.currentSellingPercent != 0 && productSuggestion.basePrice > 0 && productSuggestion.stockStatus != 8"
                class="progress-bar-width">
                <div class="progress">
                    <div class="progress-bar" role="progressbar"
                        [style]="'width:' + productSuggestion.currentSellingPercent + '%;'"></div>
                    <div class="text-white m-auto mobile"
                        style="font-size: 12px; font-weight: 700; line-height: 16px; text-transform: uppercase; z-index: 1;">
                        {{ productSuggestion.progressLabel }}
                    </div>
                </div>
            </div>

            <div class="price-rating" *ngIf="isAuthenticated && productSuggestion.basePrice <= 0">
                <a *ngIf="productSuggestion.stockStatus == 8" routerLink="/account/my-business-profile">
                    <h3 class="text-danger">Xác minh hồ sơ KD để xem giá</h3>
                </a>
                <h3 *ngIf="productSuggestion.stockStatus < 8" class="text-danger">Sản phẩm tạm thời hết hàng</h3>
            </div>
        </div>

        <ng-container *ngIf="isAuthenticated;">
            <div *ngIf="productSuggestion.stockStatus < 8 && productSuggestion.basePrice > 0 else warning"
                class="d-flex align-items-center product-list-section gap-4">
                <div class="product-info-content d-flex align-items-center no-gap flex-wrap">
                    <div class="cart_qty qty-box product-qty mt-0">
                        <span class="input-group" *ngIf="isAuthenticated">
                            <app-counter *ngIf="productSuggestion.cartItem" [cartItem]="productSuggestion.cartItem"
                                style="width: 100%"></app-counter>
                        </span>
                        <span class="input-group" *ngIf="!isAuthenticated">
                            <app-counter *ngIf="productSuggestion.cartItem" [cartItem]="productSuggestion.cartItem"
                                style="width: 100%"></app-counter>
                        </span>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <ng-container>
                    <div *ngIf="productSuggestion.productOrderLimit && productSuggestion.productOrderLimit.maxOrderQuantityPerOrder > 0"
                        style="padding-top: 5px; text-align: end;">
                        <h6>Tối đa {{ productSuggestion.productOrderLimit.maxOrderQuantityPerOrder }} sản phẩm
                            trên đơn</h6>
                    </div>
                    <div *ngIf="productSuggestion.productOrderLimit && productSuggestion.productOrderLimit.maxOrderQuantityPerDay > 0"
                        style="padding-top: 5px; text-align: end;">
                        <h6>Tối đa {{ productSuggestion.productOrderLimit.maxOrderQuantityPerDay }} sản phẩm trong
                            ngày</h6>
                    </div>
                </ng-container>
            </div>

            <ng-template #warning>
                <div>
                    <ng-container *ngIf="!productSuggestion.warningStatus || productSuggestion.warningStatus === ''">
                        <div class="out-of-stock-label" *ngIf="productSuggestion.basePrice <= 0">
                            <h5 *ngIf="productSuggestion.stockStatus != 8" class="out-of-stock-text" style="color: #CF1322;">Sản
                                phẩm tạm
                                thời
                                hết hàng</h5>
                            <a routerLink="/account/my-business-profile">
                                <h5 *ngIf="productSuggestion.stockStatus == 8" class="out-of-stock-text text-decoration-underline"
                                    style="color: #CF1322; text-underline-offset: 4px;">Xác minh hồ sơ KD để xem giá</h5>
                            </a>
                        </div>
                        <div class="out-of-stock-label" *ngIf="productSuggestion.basePrice > 0">
                            <a routerLink="/account/my-business-profile">
                                <h5 *ngIf="productSuggestion.stockStatus == 9" class="out-of-stock-text text-decoration-underline"
                                    style="color: #CF1322; text-underline-offset: 4px;">Xác minh hồ sơ KD để đặt hàng</h5>
                                <h5 *ngIf="productSuggestion.stockStatus == 10" class="out-of-stock-text text-decoration-underline"
                                    style="color: #CF1322; text-underline-offset: 4px;">Không thuộc phạm vi KD</h5>
                            </a>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="productSuggestion.warningStatus && productSuggestion.warningStatus !== ''">
                        <div class="out-of-stock-label">
                            <a [routerLink]="productSuggestion.stockStatus !== 0 ? '/account/my-business-profile': null">
                                <h5 *ngIf="productSuggestion.stockStatus == 9" class="out-of-stock-text"
                                    [class.text-decoration-underline]="productSuggestion.stockStatus !== 0"
                                    style="color: #CF1322;" [style.text-underline-offset.px]="productSuggestion.stockStatus !== 0 ? 4 : 0"
                                >
                                    {{ productSuggestion.warningStatus }}
                                </h5>
                            </a>
                        </div>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </div>
</ng-template>